var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / Arootah / Mission Statement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M32.1165 7.605C31.7361 7.3377 31.2963 7.16162 30.833 7.09104C30.3697 7.02045 29.8958 7.05735 29.4499 7.19875C28.2735 7.52129 27.055 7.67457 25.8332 7.65375C24.0275 7.55819 22.2571 7.12802 20.6165 6.38625C18.5899 5.4724 16.3978 4.95878 14.1665 4.875C9.34987 4.875 7.49987 6.5 7.16653 6.7275C7.00705 6.87991 6.8806 7.06202 6.79471 7.26301C6.70882 7.464 6.66523 7.67977 6.66653 7.8975V32.5C6.66653 32.931 6.84213 33.3443 7.15469 33.649C7.46725 33.9538 7.89117 34.125 8.3332 34.125C8.77523 34.125 9.19915 33.9538 9.51171 33.649C9.82427 33.3443 9.99987 32.931 9.99987 32.5V25.5125C11.3279 25.0167 12.7456 24.7901 14.1665 24.8463C15.9722 24.9418 17.7427 25.372 19.3832 26.1138C21.4098 27.0276 23.602 27.5412 25.8332 27.625C27.8424 27.699 29.8411 27.3092 31.6665 26.4875C32.1585 26.2622 32.5757 25.9065 32.8704 25.4612C33.165 25.0158 33.3254 24.4987 33.3332 23.9688V9.92875C33.3326 9.47533 33.2221 9.02847 33.0106 8.62463C32.7992 8.22079 32.4928 7.87141 32.1165 7.605Z",
    fill: "#8E97A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGray);
export default __webpack_public_path__ + "static/media/flag-gray.a1b28a6710c1c5300235cab87ae16112.svg";
export { ForwardRef as ReactComponent };